import { Union } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { obj_type, union_type, string_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.5/Mui.fs.js";
import { DialogActions, Button, DialogContent, ListItem, List, Divider, DialogTitle, Dialog, CardContent, CardMedia, Card, CardActionArea, MenuItem, Select, IconButton, Collapse, Icon, Tooltip, CircularProgress, Fab, Zoom, TextField, TableCell, TableRow, TableBody, Table, Typography, Paper, Grid, Alert, Snackbar } from "@mui/material";
import { uncurry2, createObj, equals } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { defaultOf } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { some, unwrap, map, defaultArg } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { cons, empty as empty_1, singleton as singleton_1, ofArray } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { op_UnaryNegation_Int32, parse } from "./fable_modules/fable-library-js.4.24.0/Int32.js";
import { empty, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import Cancel from "@mui/icons-material/Cancel";
import Save from "@mui/icons-material/Save";
import HelpOutline from "@mui/icons-material/HelpOutline";
import ChevronRight from "@mui/icons-material/ChevronRight";
import { StyleCreator$1_$ctor, StyleImports_makeStyles_get } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.5/Styles.fs.js";
import { StyleCreator$1__create_4EAC9E1E } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.5/Styles.fs.js";
import { printf, toText } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { API_Vessel_Favorite } from "./Shared/Urls.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { GenericResponse_$reflection } from "./Shared/ApiDataTypes.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_Bind, FSharpResult$2 } from "./fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { toString } from "./fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Auto_generateBoxedEncoder_437914C6, Auto_generateBoxedEncoderCached_437914C6 } from "./fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { fromString } from "./fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { Accounts_fetchAccounts, mapFetchError } from "./Promises.js";
import Favorite from "@mui/icons-material/Favorite";
import FavoriteBorder from "@mui/icons-material/FavoriteBorder";
import { useEffectOnce } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { parse as parse_1 } from "./fable_modules/fable-library-js.4.24.0/Guid.js";
import { map as map_1, tryFind } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import Add from "@mui/icons-material/Add";

export class ErrorHandling_Snackbar extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Saved", "Delete", "InProgress", "Hide", "Failed"];
    }
}

export function ErrorHandling_Snackbar_$reflection() {
    return union_type("ViewHelpers.ErrorHandling.Snackbar", [], ErrorHandling_Snackbar, () => [[], [["Item", string_type]], [], [], [["Item", string_type]]]);
}

export function ErrorHandling_Snackbar__HideTimeout(this$) {
    switch (this$.tag) {
        case 1:
            return 3000;
        case 2:
            return 4000;
        case 4:
            return 10000;
        case 3:
            return 4000;
        default:
            return 6000;
    }
}

export function ErrorHandling_Snackbar__SavedChangesText(this$) {
    switch (this$.tag) {
        case 1:
            return this$.fields[0];
        case 2:
            return "Lagrer endringer";
        case 3:
            return "";
        case 4:
            return "Lagring feilet: " + this$.fields[0];
        default:
            return "Lagret!";
    }
}

export function ErrorHandling_dynamicSnackbar(snackState, dismiss) {
    switch (snackState.tag) {
        case 1:
            return MuiHelpers_createElement(Snackbar, [["open", snackState.tag === 1], ["onClose", (_arg_1, v) => {
                dismiss();
            }], ["autoHideDuration", ErrorHandling_Snackbar__HideTimeout(snackState)], ["anchorOrigin", {
                vertical: "bottom",
                horizontal: "center",
            }], ["children", MuiHelpers_createElement(Alert, [["onClose", (_arg_2) => {
                dismiss();
            }], ["variant", "filled"], ["children", ErrorHandling_Snackbar__SavedChangesText(snackState)], ["severity", "success"]])]]);
        case 0:
            return MuiHelpers_createElement(Snackbar, [["open", equals(snackState, new ErrorHandling_Snackbar(0, []))], ["onClose", (_arg_4, v_1) => {
                dismiss();
            }], ["autoHideDuration", ErrorHandling_Snackbar__HideTimeout(snackState)], ["anchorOrigin", {
                vertical: "bottom",
                horizontal: "center",
            }], ["children", MuiHelpers_createElement(Alert, [["onClose", (_arg_5) => {
                dismiss();
            }], ["variant", "filled"], ["children", ErrorHandling_Snackbar__SavedChangesText(snackState)], ["severity", "success"]])]]);
        case 2:
            return MuiHelpers_createElement(Snackbar, [["open", equals(snackState, new ErrorHandling_Snackbar(2, []))], ["onClose", (_arg_7, v_2) => {
                dismiss();
            }], ["autoHideDuration", ErrorHandling_Snackbar__HideTimeout(snackState)], ["anchorOrigin", {
                vertical: "bottom",
                horizontal: "center",
            }], ["children", MuiHelpers_createElement(Alert, [["onClose", (_arg_8) => {
                dismiss();
            }], ["variant", "filled"], ["children", ErrorHandling_Snackbar__SavedChangesText(snackState)], ["severity", "info"]])]]);
        case 4:
            return MuiHelpers_createElement(Snackbar, [["open", snackState.tag === 4], ["onClose", (_arg_10, v_3) => {
                dismiss();
            }], ["autoHideDuration", ErrorHandling_Snackbar__HideTimeout(snackState)], ["anchorOrigin", {
                vertical: "bottom",
                horizontal: "center",
            }], ["children", MuiHelpers_createElement(Alert, [["onClose", (_arg_11) => {
                dismiss();
            }], ["variant", "filled"], ["children", ErrorHandling_Snackbar__SavedChangesText(snackState)], ["severity", "error"]])]]);
        default:
            return defaultOf();
    }
}

export function ErrorHandling_snackError(errMsg, dismiss) {
    return MuiHelpers_createElement(Snackbar, [["anchorOrigin", {
        vertical: "bottom",
        horizontal: "center",
    }], ["open", errMsg != null], ["onClose", (_arg_1, v) => {
        dismiss();
    }], ["autoHideDuration", 20000], ["children", MuiHelpers_createElement(Alert, [["severity", "error"], ["variant", "filled"], ["onClose", (_arg_2) => {
        dismiss();
    }], ["children", defaultArg(errMsg, "")]])]]);
}

export function ErrorHandling_errorBanner(errMsg, dismiss) {
    if (errMsg != null) {
        return MuiHelpers_createElement(Alert, [["severity", "error"], ["variant", "outlined"], ["onClose", (_arg) => {
            dismiss();
        }], ["children", errMsg]]);
    }
    else {
        return defaultOf();
    }
}

export function ErrorHandling_snackInfo(infoMsg, dismiss) {
    return MuiHelpers_createElement(Snackbar, [["anchorOrigin", {
        vertical: "bottom",
        horizontal: "center",
    }], ["open", infoMsg != null], ["onClose", (_arg_1, v) => {
        dismiss();
    }], ["autoHideDuration", 20000], ["children", MuiHelpers_createElement(Alert, [["severity", "info"], ["variant", "filled"], ["onClose", (_arg_2) => {
        dismiss();
    }], ["children", (infoMsg == null) ? "" : infoMsg]])]]);
}

export function GridHelpers_smallGridItem(inner) {
    return MuiHelpers_createElement(Grid, [["style", {}], ["item", true], ["xs", 12], ["sm", 12], ["md", 6], ["lg", 4], ["xl", 4], ["children", inner]]);
}

export function GridHelpers_largeGridItem(inner) {
    return MuiHelpers_createElement(Grid, [["style", {
        maxWidth: 99 + "vw",
        overflowX: "auto",
    }], ["item", true], ["xs", 12], ["md", 12], ["lg", 8], ["xl", 6], ["children", inner]]);
}

export function GridHelpers_paperSectionWithTip(tipComponent, header, contents) {
    let elements_1, elems;
    return MuiHelpers_createElement(Paper, [["style", {
        display: "flex",
        flexDirection: "column",
        padding: 16,
        height: 100 + "%",
        minWidth: 280,
    }], ["elevation", 0], (elements_1 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "space-between",
    }], (elems = [MuiHelpers_createElement(Typography, [["variant", "h6"], ["children", header]]), tipComponent], ["children", reactApi.Children.toArray(Array.from(elems))])]))), MuiHelpers_createElement(Table, [["sx", {
        tableLayout: "fixed",
    }], ["children", MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(contents))]])]])], ["children", reactApi.Children.toArray(Array.from(elements_1))])]);
}

export const GridHelpers_paperSection = (() => {
    const tipComponent = defaultOf();
    return (header) => ((contents) => GridHelpers_paperSectionWithTip(tipComponent, header, contents));
})();

export function InputForms_TextInput(inputForms_TextInputInputProps) {
    let elems_1, elems;
    const validation = inputForms_TextInputInputProps.validation;
    const onChange = inputForms_TextInputInputProps.onChange;
    const currentValue = inputForms_TextInputInputProps.currentValue;
    const label = inputForms_TextInputInputProps.label;
    const fieldId = inputForms_TextInputInputProps.fieldId;
    const patternInput = reactApi.useState(0);
    const patternInput_1 = reactApi.useState(currentValue);
    const txt = patternInput_1[0];
    const patternInput_2 = reactApi.useState(true);
    const setValid = patternInput_2[1];
    return MuiHelpers_createElement(TableRow, [["key", fieldId], (elems_1 = [MuiHelpers_createElement(TableCell, [["size", "small"], ["children", label]]), MuiHelpers_createElement(TableCell, [["size", "small"], ["align", "right"], (elems = [MuiHelpers_createElement(TextField, [["key", fieldId], ["id", fieldId], ["size", "small"], ["defaultValue", txt], ["fullWidth", true], ["error", !patternInput_2[0]], ["style", {
        maxWidth: 400,
    }], ["onBlur", (_arg) => {
        onChange(txt.trim());
    }], ["onChange", (e) => {
        const x = e.target.value;
        window.clearTimeout(patternInput[0]);
        if (validation(x)) {
            patternInput_1[1](x);
            setValid(true);
            patternInput[1](window.setTimeout((_arg_1) => {
                onChange(x.trim());
            }, 500));
        }
        else {
            setValid(false);
        }
    }]])], ["children", reactApi.Children.toArray(Array.from(elems))])])], ["children", reactApi.Children.toArray(Array.from(elems_1))])]);
}

export function InputForms_IntInput(inputForms_IntInputInputProps) {
    let elems_1, elems;
    const validation = inputForms_IntInputInputProps.validation;
    const onChange = inputForms_IntInputInputProps.onChange;
    const currentValue = inputForms_IntInputInputProps.currentValue;
    const label = inputForms_IntInputInputProps.label;
    const fieldId = inputForms_IntInputInputProps.fieldId;
    const patternInput = reactApi.useState(0);
    const patternInput_1 = reactApi.useState(currentValue);
    const txt = patternInput_1[0] | 0;
    const patternInput_2 = reactApi.useState(true);
    const setValid = patternInput_2[1];
    return MuiHelpers_createElement(TableRow, [["key", fieldId], (elems_1 = [MuiHelpers_createElement(TableCell, [["size", "small"], ["children", label]]), MuiHelpers_createElement(TableCell, [["size", "small"], ["align", "right"], (elems = [MuiHelpers_createElement(TextField, [["key", fieldId], ["id", fieldId], ["size", "small"], ["defaultValue", txt], ["fullWidth", true], ["error", !patternInput_2[0]], ["style", {
        maxWidth: 400,
    }], ["onBlur", (_arg) => {
        onChange(txt);
    }], ["onChange", (e) => {
        const x = e.target.value;
        window.clearTimeout(patternInput[0]);
        try {
            const asInt = parse(x, 511, false, 32) | 0;
            if (validation(asInt)) {
                setValid(true);
                patternInput_1[1](asInt);
                patternInput[1](window.setTimeout((_arg_1) => {
                    onChange(asInt);
                }, 500));
            }
            else {
                setValid(false);
            }
        }
        catch (matchValue) {
            setValid(false);
        }
    }]])], ["children", reactApi.Children.toArray(Array.from(elems))])])], ["children", reactApi.Children.toArray(Array.from(elems_1))])]);
}

export function InputForms_IntOptionInput(inputForms_IntOptionInputInputProps) {
    let elems_1, elems;
    const validation = inputForms_IntOptionInputInputProps.validation;
    const onChange = inputForms_IntOptionInputInputProps.onChange;
    const currentValue = inputForms_IntOptionInputInputProps.currentValue;
    const label = inputForms_IntOptionInputInputProps.label;
    const fieldId = inputForms_IntOptionInputInputProps.fieldId;
    const patternInput = reactApi.useState(0);
    const setTimer = patternInput[1];
    const patternInput_1 = reactApi.useState(currentValue);
    const updateTxt = patternInput_1[1];
    const txt = patternInput_1[0];
    const patternInput_2 = reactApi.useState(true);
    const setValid = patternInput_2[1];
    return MuiHelpers_createElement(TableRow, [["key", fieldId], (elems_1 = [MuiHelpers_createElement(TableCell, [["size", "small"], ["children", label]]), MuiHelpers_createElement(TableCell, [["size", "small"], ["align", "right"], (elems = [MuiHelpers_createElement(TextField, [["key", fieldId], ["id", fieldId], ["size", "small"], ["defaultValue", txt], ["fullWidth", true], ["error", !patternInput_2[0]], ["style", {
        maxWidth: 400,
    }], ["onBlur", (_arg) => {
        onChange(txt);
    }], ["onChange", (e) => {
        const x = e.target.value;
        window.clearTimeout(patternInput[0]);
        try {
            if (x.trim() === "") {
                setValid(true);
                updateTxt(undefined);
                setTimer(window.setTimeout((_arg_1) => {
                    onChange(undefined);
                }, 500));
            }
            else {
                const asInt = parse(x, 511, false, 32) | 0;
                if (validation(asInt)) {
                    setValid(true);
                    updateTxt(asInt);
                    setTimer(window.setTimeout((_arg_2) => {
                        onChange(asInt);
                    }, 500));
                }
                else {
                    setValid(false);
                }
            }
        }
        catch (matchValue) {
            setValid(false);
        }
    }]])], ["children", reactApi.Children.toArray(Array.from(elems))])])], ["children", reactApi.Children.toArray(Array.from(elems_1))])]);
}

export function InputForms_IntOptionInputNoRow(inputForms_IntOptionInputNoRowInputProps) {
    let elems;
    const validation = inputForms_IntOptionInputNoRowInputProps.validation;
    const onChange = inputForms_IntOptionInputNoRowInputProps.onChange;
    const currentValue = inputForms_IntOptionInputNoRowInputProps.currentValue;
    const fieldId = inputForms_IntOptionInputNoRowInputProps.fieldId;
    const patternInput = reactApi.useState(0);
    const setTimer = patternInput[1];
    const patternInput_1 = reactApi.useState(currentValue);
    const updateTxt = patternInput_1[1];
    const txt = patternInput_1[0];
    const patternInput_2 = reactApi.useState(true);
    const setValid = patternInput_2[1];
    return createElement("div", createObj(ofArray([["key", fieldId], (elems = [MuiHelpers_createElement(TextField, [["key", fieldId], ["id", fieldId], ["size", "small"], ["defaultValue", txt], ["fullWidth", true], ["error", !patternInput_2[0]], ["style", {
        maxWidth: 400,
    }], ["onBlur", (_arg) => {
        onChange(txt);
    }], ["onChange", (e) => {
        const x = e.target.value;
        window.clearTimeout(patternInput[0]);
        try {
            if (x.trim() === "") {
                setValid(true);
                updateTxt(undefined);
                setTimer(window.setTimeout((_arg_1) => {
                    onChange(undefined);
                }, 500));
            }
            else {
                const asInt = parse(x, 511, false, 32) | 0;
                if (validation(asInt)) {
                    setValid(true);
                    updateTxt(asInt);
                    setTimer(window.setTimeout((_arg_2) => {
                        onChange(asInt);
                    }, 500));
                }
                else {
                    setValid(false);
                }
            }
        }
        catch (matchValue) {
            setValid(false);
        }
    }]])], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function floatingSaveChangesButtons(responsive, changed, isDisabled, onSubmit) {
    let elems_2;
    const isBig = (responsive.tag === 4) ? true : (responsive.tag === 3);
    const wrapInZoom = (k, r) => MuiHelpers_createElement(Zoom, [["key", k], ["in", changed], ["timeout", 200], ["children", r]]);
    return createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["position", "fixed"]), delay(() => append(singleton(["gap", 5 + "px "]), delay(() => append(isBig ? append(singleton(["bottom", 10]), delay(() => singleton(["left", ("calc(" + (`calc(1vw + ${200}px )`)) + ")"]))) : append(singleton(["flexDirection", "column-reverse"]), delay(() => append(singleton(["bottom", 60]), delay(() => singleton(["left", 1 + "vw"]))))), delay(() => append(singleton(["padding", 5]), delay(() => singleton(["zIndex", 100]))))))))))))))], (elems_2 = [wrapInZoom("abort-changes-key", MuiHelpers_createElement(Fab, toList(delay(() => append(singleton(["onClick", (_arg) => {
        onSubmit(false);
    }]), delay(() => append(singleton(["variant", "extended"]), delay(() => append(singleton(["size", "large"]), delay(() => append(isBig ? singleton(["variant", "extended"]) : singleton(["variant", "circular"]), delay(() => append(singleton(["color", "secondary"]), delay(() => {
        let elems;
        return singleton((elems = toList(delay(() => {
            let props_2;
            return append(singleton((props_2 = {}, react.createElement(Cancel, props_2))), delay(() => (isBig ? singleton(MuiHelpers_createElement(Typography, [["children", "Forkast endringer"]])) : empty())));
        })), ["children", reactApi.Children.toArray(Array.from(elems))]));
    })))))))))))))), wrapInZoom("save-changes-key", MuiHelpers_createElement(Fab, toList(delay(() => append(singleton(["onClick", (_arg_1) => {
        onSubmit(true);
    }]), delay(() => append(singleton(["size", "large"]), delay(() => append(isBig ? singleton(["variant", "extended"]) : singleton(["variant", "circular"]), delay(() => append(singleton(["color", "primary"]), delay(() => append(singleton(["disabled", isDisabled]), delay(() => {
        let elems_1;
        return singleton((elems_1 = toList(delay(() => {
            let props_5;
            return append(singleton((props_5 = {}, react.createElement(Save, props_5))), delay(() => (isBig ? singleton(MuiHelpers_createElement(Typography, [["children", "Lagre endringer"]])) : empty())));
        })), ["children", reactApi.Children.toArray(Array.from(elems_1))]));
    }))))))))))))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function loadingIndicator() {
    return MuiHelpers_createElement(CircularProgress, [["size", 25], ["style", {
        color: "#0e2d7a",
    }]]);
}

export function loadingIndicatorSmall() {
    return MuiHelpers_createElement(CircularProgress, [["size", 15], ["style", {
        color: "#0e2d7a",
    }]]);
}

export function loadingIndicatorLarge() {
    return MuiHelpers_createElement(CircularProgress, [["size", 40], ["style", {
        color: "#0e2d7a",
    }]]);
}

export function wrapTooltip(title, x) {
    return MuiHelpers_createElement(Tooltip, [["title", title], ["children", x]]);
}

export function helperText(helperText_1) {
    let elems, props_1;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        marginRight: 10,
        alignItems: "center",
        gap: 5 + "px ",
    }], (elems = [(props_1 = {
        style: {
            fontSize: 1.25 + "rem",
        },
    }, react.createElement(HelpOutline, props_1)), MuiHelpers_createElement(Typography, [["children", `Tips: ${helperText_1}`]])], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function tryFocus(elemId) {
    try {
        window.document.getElementById(elemId).focus();
    }
    catch (matchValue) {
    }
}

export function collapsableHeader(title, collapsed, setCollapsed) {
    let elems_1, elements, props_1;
    return createElement("div", createObj(ofArray([["onClick", (_arg) => {
        setCollapsed(!collapsed);
    }], ["style", {
        marginTop: 1 + "rem",
        marginBottom: 1 + "rem",
        cursor: "pointer",
        width: 100 + "%",
        display: "flex",
        alignItems: "center",
    }], (elems_1 = [MuiHelpers_createElement(Icon, [["style", createObj(toList(delay(() => append(singleton(["fontSize", 1.5 + "rem"]), delay(() => append(singleton(["transitionProperty", "transform"]), delay(() => append(singleton(["transitionDuration", 300 + "ms"]), delay(() => append(singleton(["display", "flex"]), delay(() => (!collapsed ? singleton(["transform", ("rotate(" + 90) + "deg)"]) : empty()))))))))))))], (elements = [(props_1 = {}, react.createElement(ChevronRight, props_1))], ["children", reactApi.Children.toArray(Array.from(elements))])]), MuiHelpers_createElement(Typography, [["style", {
        marginLeft: 3,
    }], ["variant", "h5"], ["children", title]])], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function indentedListComponent(s, children) {
    return createElement("div", {
        style: createObj(toList(delay(() => append(singleton(["gap", 16 + "px "]), delay(() => append(singleton(["padding", 24]), delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["maxWidth", 1200]), delay(() => append(singleton(["borderRadius", 10]), delay(() => append(singleton(["justifyContent", "center"]), delay(() => append(singleton(["backgroundColor", "#E7EBF0"]), delay(() => s))))))))))))))))),
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

/**
 * Component with expanding filter/body when clicking header
 */
export function CollapsibleContainerWithFilter(collapsibleContainerWithFilterInputProps) {
    let elems_4, elems_1, elements_2;
    const defaultState = collapsibleContainerWithFilterInputProps.defaultState;
    const bodyContent = collapsibleContainerWithFilterInputProps.bodyContent;
    const filterContent = collapsibleContainerWithFilterInputProps.filterContent;
    const headerContent = collapsibleContainerWithFilterInputProps.headerContent;
    const patternInput = reactApi.useState(defaultState);
    const collapsed = patternInput[0];
    return MuiHelpers_createElement(Paper, [["style", {
        padding: 20,
        paddingTop: 5,
        width: 100 + "%",
        maxWidth: 800,
    }], (elems_4 = [createElement("div", createObj(ofArray([["onClick", (_arg) => {
        patternInput[1](!collapsed);
    }], ["style", {
        marginTop: 1 + "rem",
        marginBottom: 1 + "rem",
        cursor: "pointer",
        width: 100 + "%",
        display: "flex",
        alignItems: "center",
    }], (elems_1 = toList(delay(() => {
        let elements, props_1;
        return append(singleton(MuiHelpers_createElement(Icon, [["style", createObj(toList(delay(() => append(singleton(["fontSize", 2 + "rem"]), delay(() => append(singleton(["transitionProperty", "transform"]), delay(() => append(singleton(["transitionDuration", 300 + "ms"]), delay(() => append(singleton(["display", "flex"]), delay(() => (!collapsed ? singleton(["transform", ("rotate(" + 90) + "deg)"]) : empty()))))))))))))], (elements = [(props_1 = {
            style: {
                fontSize: 1.75 + "rem",
            },
        }, react.createElement(ChevronRight, props_1))], ["children", reactApi.Children.toArray(Array.from(elements))])])), delay(() => headerContent));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), MuiHelpers_createElement(Collapse, [["in", !collapsed], ["collapsedSize", "200px"], (elements_2 = toList(delay(() => {
        let elements_1;
        return append(singleton(MuiHelpers_createElement(Collapse, [["in", !collapsed], (elements_1 = toList(delay(() => filterContent)), ["children", reactApi.Children.toArray(Array.from(elements_1))])])), delay(() => bodyContent));
    })), ["children", reactApi.Children.toArray(Array.from(elements_2))])])], ["children", reactApi.Children.toArray(Array.from(elems_4))])]);
}

/**
 * Common collapsable side-drawer styles
 */
export function DrawerMenu_drawerStyles() {
    let f1, styles;
    return void StyleImports_makeStyles_get((f1 = ((styles = StyleCreator$1_$ctor(), (theme) => {
        let arg;
        const root = StyleCreator$1__create_4EAC9E1E(styles, singleton_1(["display", "flex"]));
        const toolbar = StyleCreator$1__create_4EAC9E1E(styles, ofArray([["color", "#2F4F4F"], ["backgroundColor", "#F5F5F5"]]));
        const menuButton = StyleCreator$1__create_4EAC9E1E(styles, ofArray([["marginRight", theme.spacing(2)], ["color", "#2F4F4F"]]));
        const hide = StyleCreator$1__create_4EAC9E1E(styles, singleton_1(["display", "none"]));
        const drawer = StyleCreator$1__create_4EAC9E1E(styles, ofArray([["width", 200], ["flexShrink", 0]]));
        const drawerPaper = StyleCreator$1__create_4EAC9E1E(styles, ofArray([["top", 4 + "rem"], ["overflowY", "hidden"], ["width", 200]]));
        const drawerHeader = StyleCreator$1__create_4EAC9E1E(styles, toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["alignItems", "center"]), delay(() => append(singleton(["padding", theme.spacing(0, 1)]), delay(() => append(Object.entries(theme.mixins.toolbar), delay(() => singleton(["justifyContent", "flex-end"]))))))))))));
        const content = StyleCreator$1__create_4EAC9E1E(styles, ofArray([["marginLeft", op_UnaryNegation_Int32(200)], ["width", "calc(100vw - 30px)"], ["minWidth", 400], ["backgroundColor", "#fff"], ["overflowY", "auto"], ["height", 100 + "vh"]]));
        const contentShift = StyleCreator$1__create_4EAC9E1E(styles, ofArray([["marginLeft", 0], ["width", (arg = 230, toText(printf("calc(100vw - %ipx)"))(arg))], ["height", "initial"]]));
        return {
            buttonChevron: StyleCreator$1__create_4EAC9E1E(styles, ofArray([["transitionProperty", "transform"], ["transitionDuration", 300 + "ms"], ["fontSize", 1 + "rem"]])),
            collapseButtonDiv: StyleCreator$1__create_4EAC9E1E(styles, ofArray([["cursor", "pointer"], ["width", 100 + "%"], ["display", "flex"], ["height", 48], ["alignItems", "center"]])),
            content: content,
            contentShift: contentShift,
            drawer: drawer,
            drawerHeader: drawerHeader,
            drawerPaper: drawerPaper,
            hide: hide,
            menuButton: menuButton,
            root: root,
            toolbar: toolbar,
        };
    })), (arg_1) => {
        const o = f1(arg_1);
        return Object.assign({}, o);
    }))();
}

export function Vessel_ToggleFavoriteButton(vessel_ToggleFavoriteButtonInputProps) {
    let elements;
    const onUpdate = vessel_ToggleFavoriteButtonInputProps.onUpdate;
    const favorite = vessel_ToggleFavoriteButtonInputProps.favorite;
    const vesselId = vessel_ToggleFavoriteButtonInputProps.vesselId;
    const patternInput = reactApi.useState(false);
    const setUpdating = patternInput[1];
    return MuiHelpers_createElement(IconButton, [["onClick", (ev) => {
        let properties_2, properties_6;
        ev.preventDefault();
        ev.stopPropagation();
        const url = API_Vessel_Favorite(vesselId);
        setUpdating(true);
        let pr_3;
        let pr_2;
        if (favorite) {
            const decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined);
            const data_1 = "";
            const caseStrategy_2 = undefined;
            const extra_2 = undefined;
            try {
                const properties_3 = Helper_withProperties(singleton_1(new Types_RequestProperties(3, ["cors"])), (properties_2 = ofArray([new Types_RequestProperties(0, ["DELETE"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(string_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                pr_2 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
            }
            catch (exn) {
                pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        }
        else {
            const body_2 = Auto_generateBoxedEncoder_437914C6(string_type, undefined, undefined, undefined)("");
            const decoder_3 = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined);
            const data_5 = some(body_2);
            const caseStrategy_11 = undefined;
            const extra_11 = undefined;
            try {
                const properties_3_1 = Helper_withProperties(singleton_1(new Types_RequestProperties(3, ["cors"])), (properties_6 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_5, empty_1()), 0)])]), defaultArg(map((data_1_2) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_11), unwrap(extra_11))(data_1_2))]), properties_6), data_5), properties_6)));
                const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3_1).then((_arg_2) => {
                    let response_3, decoder_1_2;
                    return ((response_3 = _arg_2, (decoder_1_2 = defaultArg(decoder_3, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_11), unwrap(extra_11))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_3.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_3.text().then((_arg_3) => {
                        let matchValue_1;
                        return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_2), _arg_3), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_3])])))).then((_arg_1_2) => (Promise.resolve(_arg_1_2)))))))));
                }))));
                pr_2 = (pr_1.then(void 0, ((arg_1) => (new FSharpResult$2(1, [new FetchError(3, [arg_1])])))));
            }
            catch (exn_1) {
                pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn_1])])))));
            }
        }
        pr_3 = (pr_2.then(mapFetchError));
        pr_3.then((res_1) => {
            onUpdate(Result_Bind((resp) => {
                if (resp.Result === "success") {
                    return new FSharpResult$2(0, [!favorite]);
                }
                else {
                    return new FSharpResult$2(1, [resp.Message]);
                }
            }, res_1));
            setUpdating(false);
        });
    }], ["disableRipple", true], (elements = toList(delay(() => {
        let props_3, props_5;
        return patternInput[0] ? singleton(loadingIndicatorSmall()) : (favorite ? singleton((props_3 = {}, react.createElement(Favorite, props_3))) : singleton((props_5 = {}, react.createElement(FavoriteBorder, props_5))));
    })), ["children", reactApi.Children.toArray(Array.from(elements))])]);
}

/**
 * Drop-down selection that fetches users for you
 */
export function UserSelect(userSelectInputProps) {
    let elements;
    const onSelect = userSelectInputProps.onSelect;
    const account = userSelectInputProps.account;
    const patternInput = reactApi.useState([]);
    const users = patternInput[0];
    const accountId = defaultArg(map((a) => a.Id, account), "");
    useEffectOnce(() => {
        Accounts_fetchAccounts((_arg) => {
            if (_arg.tag === 1) {
                console.error(some(_arg.fields[0]));
            }
            else {
                patternInput[1](_arg.fields[0]);
            }
        });
    });
    if (users.length === 0) {
        return defaultOf();
    }
    else {
        return MuiHelpers_createElement(Select, [["label", "Forfatter"], ["value", accountId], ["onChange", (e, _arg_1) => {
            const userIdGuid = parse_1(e.target.value);
            onSelect(tryFind((u) => (u.Id === userIdGuid), users));
        }], (elements = [map_1((u_1) => MuiHelpers_createElement(MenuItem, [["children", u_1.Name], ["value", u_1.Id]]), users)], ["children", reactApi.Children.toArray(Array.from(elements))])]);
    }
}

/**
 * Typogaphy caption, using p with margin-bottom 2px
 */
export function simpleCaption(text) {
    return MuiHelpers_createElement(Typography, [["style", {
        marginBottom: 2,
    }], ["component", "p"], ["variant", "caption"], ["children", text]]);
}

/**
 * Flexible and clickable mui-card. Used as basis for route and vessel cards.
 */
export function responsiveCard(styles, href, imageAlt, imageUrl, cardContent) {
    let elems_2, elems_1;
    const cardSize = toList(delay(() => append(singleton(["width", 100 + "%"]), delay(() => append(singleton(["height", 350]), delay(() => styles))))));
    return MuiHelpers_createElement(CardActionArea, [["href", href], ["style", createObj(toList(delay(() => append(cardSize, delay(() => singleton(["borderRadius", 4]))))))], (elems_2 = [MuiHelpers_createElement(Card, [["style", createObj(cardSize)], (elems_1 = [MuiHelpers_createElement(CardMedia, [["style", {
        height: 50 + "%",
        backgroundSize: "contain",
    }], ["alt", imageAlt], ["image", imageUrl]]), MuiHelpers_createElement(CardContent, [["children", reactApi.Children.toArray(Array.from(cardContent))]])], ["children", reactApi.Children.toArray(Array.from(elems_1))])])], ["children", reactApi.Children.toArray(Array.from(elems_2))])]);
}

export function listAddButton(title, onClick) {
    let elems_3, elems_2, elems_1, elements, props_1;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexGrow: 1,
        flexBasis: 0,
        flexShrink: 1,
        minWidth: 225,
        maxWidth: 225,
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
    }], (elems_3 = [MuiHelpers_createElement(CardActionArea, [["onClick", (_arg) => {
        onClick();
    }], ["style", {
        width: 100 + "%",
        height: 350,
        borderRadius: 4,
    }], (elems_2 = [MuiHelpers_createElement(Card, [["style", {
        width: 100 + "%",
        height: 350,
    }], (elems_1 = [MuiHelpers_createElement(CardContent, [["style", {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: 100 + "%",
        gap: 20 + "px ",
    }], (elements = [(props_1 = {
        style: {
            fontSize: 3 + "rem",
        },
    }, react.createElement(Add, props_1)), MuiHelpers_createElement(Typography, [["variant", "h6"], ["children", title]])], ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elems_1))])])], ["children", reactApi.Children.toArray(Array.from(elems_2))])])], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

/**
 * Draw a dialog to confirm the choice of deleting a vessel attribute that
 * has vessels depending on it. Draws a given list of the dependent vessels.
 */
export function deleteDependenciesDialog(name, parentName, deps, onClose, tryDelete) {
    let elements_3, children, children_1;
    return MuiHelpers_createElement(Dialog, [["open", true], ["onClose", (_arg_1, v) => {
        onClose(undefined);
    }], ["scroll", "paper"], ["style", {
        maxHeight: 70 + "vh",
    }], (elements_3 = [MuiHelpers_createElement(DialogTitle, [["children", `Er du sikker på at du vil slette ${name}?`]]), (children = toList(delay(() => {
        let elems_1;
        if (deps != null) {
            const d = deps;
            return singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 10 + "px ",
            }], (elems_1 = toList(delay(() => ((d.length === 0) ? singleton(MuiHelpers_createElement(Alert, [["severity", "success"], ["children", `Ingen ${parentName} bruker denne typen`]])) : append(singleton(MuiHelpers_createElement(Alert, [["severity", "error"], ["children", "Dette vil slette alle verdier som bruker denne typen"]])), delay(() => append(singleton(MuiHelpers_createElement(Typography, [["variant", "caption"], ["children", `${d.length} ${parentName} er oppført med ${name}`]])), delay(() => append(singleton(MuiHelpers_createElement(Divider, [])), delay(() => {
                let elements;
                return singleton(MuiHelpers_createElement(List, [["dense", true], (elements = [map_1((d$0027) => MuiHelpers_createElement(ListItem, [["children", [d$0027.Name]]]), d)], ["children", reactApi.Children.toArray(Array.from(elements))])]));
            }))))))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
        }
        else {
            return singleton(loadingIndicator());
        }
    })), MuiHelpers_createElement(DialogContent, [["children", reactApi.Children.toArray(Array.from(children))]])), (children_1 = ofArray([MuiHelpers_createElement(Button, [["variant", "outlined"], ["children", "Avbryt"], ["onClick", (_arg_2) => {
        onClose(undefined);
    }]]), MuiHelpers_createElement(Button, [["children", "Slett"], ["onClick", (_arg_3) => {
        tryDelete();
    }]])]), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_1))]]))], ["children", reactApi.Children.toArray(Array.from(elements_3))])]);
}

//# sourceMappingURL=ViewHelpers.js.map
